'use strict';

module.exports = {
    cityDropdown: function () {
        $('body').on('change', '.state-dropdown-select', function () {
            var formAction = $(this).attr('data-action');
            var selectedCity = $(this).val();
            $.spinner().start();
            $.ajax({
                url: formAction,
                method: 'GET',
                data: { city: selectedCity },
                dataType: 'json',
                success: function (data) {
                    $('.stores-list-details').empty();
                    $('.stores-list-details').append(data.renderingDetails);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
